import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import M from "moment";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {configTableDailyMonitoring} from "../config";
import SimpleInput from "../../../../../modules/SimpleInput";
import {fetchDataAsync, FormatCurrencyWithoutSymbol} from "../../../../../Services/Utils";
import {removeNullFields} from "../../../../common/mapper";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import {HttpStatus} from "../../../../common/Constants";
import Api from "../../../../../Services/Api";

class MonitoringDailyUnitProfit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: M(new Date()).format("DD-MM-yyyy"),
            endDate: M(new Date()).format("DD-MM-yyyy"),
            dataTable: [],
            totalProfit: 0,
            averageProfit: 0,
        };
    };

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (!R.equals(R.sortBy(R.identity, prevProps.listCabang), R.sortBy(R.identity, this.props.listCabang))) {
            this.setState((prevValue) => ({...prevValue, dataTable: []}));
        }
    };

    handlePeriodChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: M(value).format("DD-MM-yyyy"),
        }));
    };

    fetchData = async () => {
        this.props.triggerLoading();
        let {startDate, endDate} = this.state;
        let {listCabang} = this.props;
        const request = removeNullFields({
            listCabang,
            startDate,
            endDate,
        });
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT_DTO").getDataProfitUnitDailyAccounting,
            menuName: "Dashboard Akunting - Monitoring Profit Unit Bruto Harian",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data.dataProfitUnitDaily,
                totalProfit:res.data.data.totalProfit,
                averageProfit:res.data.data.averageProfit,
            }));
        }
        this.props.triggerLoading();
    };

    render() {
        let {startDate, endDate, totalProfit, averageProfit} = this.state;
        return (
            <>
                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                    <SimpleDate
                        id="select_date_startFJDate"
                        name="startDate"
                        nextdate
                        date={startDate}
                        maxDate={endDate}
                        onChange={(value) => this.handlePeriodChange("startDate", value)}
                    />
                    <SimpleDate
                        id="select_date_endFJDate"
                        name="endDate"
                        backdate
                        date={endDate}
                        minDate={startDate}
                        onChange={(value) => this.handlePeriodChange("endDate", value)}
                    />
                    <SimpleButton
                        text="Cari"
                        className="margin-bottom-15px"
                        onClick={this.fetchData}
                    />
                </FlexView>
                <p style={{fontWeight: "bold", marginBottom: "10px"}}>
                    MONITORING PROFIT UNIT BRUTO HARIAN
                </p>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={configTableDailyMonitoring}
                    rowsPerPage={5}
                    page={0}
                    options={{...defaultTableChange, serverSide: false}}
                />
                <FlexView style={{justifyContent: "end", marginTop: "15px"}}>
                    <div>
                        <SimpleInput
                            label="Total Profit"
                            readOnly
                            value={FormatCurrencyWithoutSymbol({number: totalProfit})}
                        />
                        <SimpleInput
                            label="Rata-Rata Profit"
                            readOnly
                            value={FormatCurrencyWithoutSymbol({number: averageProfit})}
                        />
                    </div>
                </FlexView>
            </>
        );
    };
}

export default MonitoringDailyUnitProfit;